import { render, staticRenderFns } from "./AnatomyMarkerContent.vue?vue&type=template&id=1d6a80ab&scoped=true"
import script from "./AnatomyMarkerContent.vue?vue&type=script&lang=js"
export * from "./AnatomyMarkerContent.vue?vue&type=script&lang=js"
import style0 from "./AnatomyMarkerContent.vue?vue&type=style&index=0&id=1d6a80ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a80ab",
  null
  
)

export default component.exports